import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-foreground-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-950">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="font-display text-xl tracking-wide text-foreground-50">电影天堂</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-300">
            电影天堂专注于最新电影推荐与影视资源内容分享，为每一位电影爱好者提供便捷的查找、浏览与了解最新电影信息的体验。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-foreground-50">电影分类</h4>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-foreground-300">
            {movieCategories.map((cat) => (
              <li key={cat.slug}>
                <Link to={`/category/${cat.slug}`} className="transition hover:text-accent-400">
                  {cat.name}电影
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-medium text-foreground-50">快速导航</h4>
          <ul className="mt-4 space-y-2 text-sm text-foreground-300">
            <li><Link to="/" className="transition hover:text-accent-400">首页</Link></li>
            <li><Link to="/news" className="transition hover:text-accent-400">电影资讯</Link></li>
            <li><Link to="/category/action" className="transition hover:text-accent-400">最新电影</Link></li>
            <li><Link to="/about" className="transition hover:text-accent-400">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-medium text-foreground-50">联系方式</h4>
          <ul className="mt-4 space-y-2 text-sm text-foreground-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-400" />
              contact@dianyingtiantang.demo
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-accent-400" />
              北京市朝阳区影城路 88 号
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-400" />
              每日 09:00 - 23:00
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-foreground-100/10">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-400 md:flex-row md:px-6">
          <p>© 2025 电影天堂 · 本站所有内容均为演示用模拟数据，仅供学习参考</p>
          <p>信息展示平台 · 不含下载与播放功能</p>
        </div>
      </div>
    </footer>
  );
}